<template>
  <div class="signup app-content" :class="{'bg-gray': !payment}">
    <div class="container mt-5" v-if="payment">
      <div class="row mt-5 ">
        <div class="col-12 col-md-5 mx-auto done ">
          <h4 class="text-center"><b>{{$t("message.choose_payment")}}</b></h4>
          <p class="mt-5 mb-2 "><b>{{$t("message.service_content")}}</b></p>
          <p > 
            {{$t("message.article6_sub1")}} <br>
            {{$t("message.test_info_service")}} 
          </p>

          <p class="mt-4 mb-2"><b>{{$t("message.usage_fee")}}</b></p>
          <p>{{$t("message.test_fee")}}</p>


          <p class="mt-4 mb-2"><b>{{$t("message.method_payment")}}</b></p>


          <b-form-group>
            <div class="form-group commonStyle"> 
              <b-form-radio v-model="method" name="some-radios" value="credit_card"><b>{{$t("message.credit_card")}}</b></b-form-radio>
              <div v-if="method == 'credit_card'" class="text-center mt-3">
                <div ref="paypal"></div>
              </div>
            </div>
          </b-form-group>
        </div>
      </div>
    </div>


    <div class="container bg-gray"  v-if="!payment">
      <div class="row pt-5 pb-5">
        <div class="col-12 col-md-7 mx-auto px-0 done ">
          <b-card class="px-5 py-4 text-center">
            <h4 class="text-center"><b>{{$t("message.copmplete_payment")}}</b></h4>
            <p class="mt-5 text-center">{{$t("message.copmplete_payment_descript")}}</p>

            <router-link :to="'/mypage'">
              <b-button  class="next py-2 px-4 mt-4"> {{$t("message.start_sevice")}} </b-button>
            </router-link>
          </b-card> 
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'; 
// import Paypal from "@/components/Setting/Paypal"
import axios from 'axios';
export default {
  data () {
    return {
      idToken: localStorage.idToken,
      styleA:true,
      styleB:false,
      line_qr: "http://placehold.jp/90x90.png?text=click ",
      method: "",
      payed: false,
      payment: true,
      payment_info: {},
    }
  },
  methods: {
    uploadFile: function(event){
      this.styleA = true;
      this.styleB = false;
      const files = event.target.files ? event.target.files : event.dataTransfer.files;
      const file = files[0];
      const reader = new FileReader();
      reader.onload = event => {
        this.line_qr = event.target.result;
      };
      reader.readAsDataURL(file);
      document.getElementById("line_qr").files = files;
      this.payed = true
    },
    changeStyle: function(event,flag){
        if(flag=='ok'){
            this.styleA = false;
            this.styleB = true;
        }else{
            this.styleA = true;
            this.styleB = false;
        }
    },
    testfunction(){
      console.log('fdadf')
    },
    registPayment(res){
      this.payment_info['pay_method'] = this.method
      this.payment_info['payment_status'] = res.stste
      this.payment_info['payer_id'] = res.payer.payer_info.payer_id
      this.payment_info['payment_id'] = res.id
      this.payment_info['payment_other'] = JSON.stringify(res)
      axios
      .patch(process.env.VUE_APP_API + "/users/" + this.memberInfo.id,{user: this.payment_info},{headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then((response) => {
        this.payment = false
        console.log(response)
      }).catch(() => {
        var locate = this.$i18n.locale
        this.$swal.fire({
          icon: 'error',
          title: this.$i18n.messages[locate]['message']["fault_payment1"],
          text: this.$i18n.messages[locate]['message']["fault_payment2"] ,
        }).then(()=>{
        })
      })
      
    },
    async setLoaded() {
        var token = this.idToken 
        var userId = this.memberInfo.id
        var payment_info = {}
        payment_info['pay_method'] = 'credit_card'

        await window.paypal.Buttons({
          style: {
              shape: 'rect',
              color: 'gold',
              layout: 'vertical',
              label: 'subscribe',
          },
          createSubscription: function(data, actions) {
            return actions.subscription.create({
              'plan_id': 'P-3TX37697KS352073CL5PXPXQ'
            });
          },
          onApprove(data) {
            if(data.subscriptionID){
              payment_info['payment_id'] = data.subscriptionID
              payment_info['payment_other'] = JSON.stringify(data)
              axios
              .patch(process.env.VUE_APP_API + "/users/" + userId, {user: payment_info}, {headers: {'Authorization': 'Bearer ' + token}})
              .then(() => {
                window.location.href = './succeedPayment';
              }).catch(() => {
              })
             }
          }
        }).render(this.$refs.paypal)
    }
  },
  mounted() {
    console.log(this.memberInfo)
    if(this.memberInfo.status == "member"){
      this.$router.push('./mypage')
    }else{
      if(this.memberInfo.status == "associate_member"){
        this.$router.push('./createuser')
      }
    }
    this.$store.commit('setLoading', false)
  },
  watch: {
    method(val){
      if(val == 'credit_card'){
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', "https://static.zdassets.com/ekr/snippet.js?key=009d7ce8-554b-4ef7-b395-e15724a1bd5a")
        recaptchaScript.id = "ze-snippet"
        document.head.appendChild(recaptchaScript)

        this.$zendesk.show()

        let paypalScript = document.createElement('script')
        paypalScript.setAttribute('src', "https://www.paypal.com/sdk/js?client-id=AdxI0i-euVBX9ZgJ2TLejuQyHoGReuB7DBtS43IlI7fhXt4GKr_9P6jyBf4uAVHQsUvgQ_zG8bPTaxA6&vault=true")
        paypalScript.addEventListener("load", this.setLoaded)
        document.body.appendChild(paypalScript)
      }
    }
  },
  computed: {
    ...mapState({
        memberInfo: state => state.user.user
    })
  },

}
</script>

<style scoped lang="scss">
.commonStyle{ 
  padding: 2rem;
  border: 1px solid rgba(1, 1, 20, 0.12);
  border-radius: 4px;
  background-size: contain !important;
  background-repeat : no-repeat !important;
}

.styleB{
  border:3px dotted rgba(0,200,0,0.7);
}

.line-qr{
  margin-top: 10px;
  margin-left: 30px;
  width: 90px;
  height: 90px;
  background: #C4C4C4;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

.save-qr{
  margin-top: 35px;
  background: #FFFFFF !important;
  color: rgba(1, 1, 20, 0.87);
  font-size: 14px;
  border: 1px solid rgba(1, 1, 20, 0.87);
  border-radius: 18.5px;
}

.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}
</style>
